module.exports = __webpack_public_path__ + "static/media/39.956a1041.mp3";